import React from 'react';
import { Shield, AlertTriangle } from 'lucide-react';
export function ScienceSection() {
  return <section className="py-20 lg:py-32 px-6 bg-sage-light/30" data-id="element-167">
      <div className="max-w-7xl mx-auto" data-id="element-168">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-169">
          <div data-id="element-170">
            <span className="text-sage font-serif italic text-xl mb-2 block" data-id="element-171">
              Chapter 2
            </span>
            <h2 className="text-4xl lg:text-5xl font-serif text-charcoal mb-6" data-id="element-172">
              The Science of the <br data-id="element-173" />
              "Safety Switch"
            </h2>
            <p className="text-lg text-charcoal/80 mb-6 leading-relaxed" data-id="element-174">
              Your body has two primary modes: <strong data-id="element-175">Survival</strong>{' '}
              (Sympathetic) and <strong data-id="element-176">Safety</strong> (Parasympathetic).
            </p>
            <p className="text-charcoal/80 mb-8 leading-relaxed" data-id="element-177">
              Most weight loss advice (HIIT, fasting, 1200 calories) pushes a
              stressed body deeper into <em data-id="element-178">Survival Mode</em>. Your brain
              thinks there is a famine or a war, so it holds onto every gram of
              fat to protect you.
            </p>

            <div className="p-6 bg-white border-l-4 border-gold shadow-sm" data-id="element-179">
              <p className="text-charcoal font-medium italic font-serif text-lg" data-id="element-180">
                "We must signal 'Safety' to the nervous system. When the body
                feels safe, it releases the water/inflammation and allows the
                metabolism to restart."
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6" data-id="element-181">
            {/* Survival Mode Card */}
            <div className="bg-white p-8 border border-red-100 shadow-sm relative overflow-hidden group" data-id="element-182">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-183">
                <AlertTriangle className="w-24 h-24 text-red-900" data-id="element-184" />
              </div>
              <div className="relative z-10" data-id="element-185">
                <h3 className="text-2xl font-serif text-charcoal mb-2 flex items-center gap-2" data-id="element-186">
                  <span className="w-2 h-2 rounded-full bg-red-400" data-id="element-187"></span>
                  Survival Mode
                </h3>
                <p className="text-sm text-charcoal/60 uppercase tracking-wider mb-4" data-id="element-188">
                  Sympathetic Nervous System
                </p>
                <ul className="space-y-2 text-charcoal/80" data-id="element-189">
                  <li className="flex items-start gap-2" data-id="element-190">
                    <span className="text-red-400 mt-1.5 text-xs" data-id="element-191">●</span>
                    <span data-id="element-192">Retains sodium & water</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-193">
                    <span className="text-red-400 mt-1.5 text-xs" data-id="element-194">●</span>
                    <span data-id="element-195">Halts digestion & metabolism</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-196">
                    <span className="text-red-400 mt-1.5 text-xs" data-id="element-197">●</span>
                    <span data-id="element-198">Increases visceral fat storage</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Safety Mode Card */}
            <div className="bg-sage text-white p-8 shadow-lg relative overflow-hidden transform lg:translate-x-8 lg:-translate-y-4 transition-transform hover:lg:-translate-y-6" data-id="element-199">
              <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-200">
                <Shield className="w-24 h-24 text-white" data-id="element-201" />
              </div>
              <div className="relative z-10" data-id="element-202">
                <h3 className="text-2xl font-serif text-white mb-2 flex items-center gap-2" data-id="element-203">
                  <span className="w-2 h-2 rounded-full bg-gold" data-id="element-204"></span>
                  Safety Mode
                </h3>
                <p className="text-sm text-white/60 uppercase tracking-wider mb-4" data-id="element-205">
                  Parasympathetic Nervous System
                </p>
                <ul className="space-y-2 text-white/90" data-id="element-206">
                  <li className="flex items-start gap-2" data-id="element-207">
                    <span className="text-gold mt-1.5 text-xs" data-id="element-208">●</span>
                    <span data-id="element-209">Flushes inflammation</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-210">
                    <span className="text-gold mt-1.5 text-xs" data-id="element-211">●</span>
                    <span data-id="element-212">Restores metabolic function</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-213">
                    <span className="text-gold mt-1.5 text-xs" data-id="element-214">●</span>
                    <span data-id="element-215">Deep, restorative sleep</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}